import { render, staticRenderFns } from "./HolidaySettingsPage.vue?vue&type=template&id=e71f1828&scoped=true&"
import script from "./HolidaySettingsPage.vue?vue&type=script&lang=js&"
export * from "./HolidaySettingsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e71f1828",
  null
  
)

export default component.exports